import { FormInput } from "src/components/ui/FormInput";
import { cn } from "src/lib/utils";

interface GuestIdentityFormProps {
  name: string;
  email: string;
  onNameChange: (v: string) => void;
  onEmailChange: (v: string) => void;
  errors?: { name?: string; email?: string };
}

export function GuestIdentityForm({
  name,
  email,
  onNameChange,
  onEmailChange,
  errors,
}: GuestIdentityFormProps) {
  const emailDescribedBy = [errors?.email ? "guest-email-error" : null, "guest-email-help"]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="flex flex-col gap-5">
      <div>
        <FormInput
          label="Name"
          id="guest-name"
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          autoComplete="name"
          aria-invalid={errors?.name ? true : undefined}
          aria-describedby={errors?.name ? "guest-name-error" : undefined}
          valueClassName={cn(errors?.name && "border-red-600 focus-visible:ring-red-600")}
        />
        {errors?.name && (
          <p id="guest-name-error" className="mt-1.5 text-sm text-red-700" role="alert">
            {errors.name}
          </p>
        )}
      </div>

      <div>
        <FormInput
          label="Email"
          id="guest-email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          autoComplete="email"
          aria-invalid={errors?.email ? true : undefined}
          aria-describedby={emailDescribedBy}
          valueClassName={cn(errors?.email && "border-red-600 focus-visible:ring-red-600")}
        />
        {errors?.email && (
          <p id="guest-email-error" className="mt-1.5 text-sm text-red-700" role="alert">
            {errors.email}
          </p>
        )}
        <p id="guest-email-help" className="mt-1.5 text-sm text-gray-600">
          No account is created.
        </p>
      </div>
    </div>
  );
}

export default GuestIdentityForm;
